import React from "react"

const ChooseExperience = () => {
  return (
    <div className="choose" id="liveexperience">
      <div className="container">
        <div className="choose__content">
          <div className="choose__border"></div>

          <div className="choose__text">
            <h1 className="choose__text--heading">
              Choose Your <br />
              Experience
            </h1>
            <p className="choose__text--description">
              Whether you are looking to find your zen, fill your belly, make a
              friend, lift your voice or plan your future, there is an
              experience below for everyone.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChooseExperience
